export enum STRIPE_STATUS {
	CANCELLED = 'canceled',
	PAST_DUE = 'past_due',
	ACTIVE = 'active',
	TRIALLING = 'trialing',
	INCOMPLETE = 'incomplete'
}
